import {Component, Input, OnInit} from '@angular/core';
import {UserType} from '../../_types/user.type';
import {ActivatedRoute} from '@angular/router';
import {TicketType} from '../../_types/ticket.type';

@Component({
  selector: 'app-shared-ticket-page',
  templateUrl: './shared-ticket-page.component.html',
  styleUrls: ['./shared-ticket-page.component.scss']
})
export class SharedTicketPageComponent implements OnInit {

  @Input() ticketUid: string;
  @Input() serviceUid: string;

  user: UserType;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    // set user
    // @ts-ignore
    this.user = this.route.snapshot.parent.parent.data.user;
  }

}
